import { Component, Input, OnInit } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DialogFullscreenCodeComponent } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service/src/services';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'app-customize-object-config',
  templateUrl: './customize-object-config.component.html',
  styleUrls: ['./customize-object-config.component.scss']
})
export class AtwCustomizeObjectConfig extends AtwUpdateDbComponent {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  activeTab: string = 'html'; // Tab mặc định
  @Input() type: any;


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogFullscreenCodeComponent>,
    public vhEventMediator: VhEventMediator,
    public vhQueryAutoWeb: VhQueryAutoWeb,
        public functionService: FunctionService
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width height của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['customize-object']['width'] = event.width + 'px';
    if (event.height) this.class['customize-object']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  // /**
  // *Hàm update config vào database.
  // */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {[this.device + '_config']: this.config,})
  // }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class,
  //     [this.device + '_config']: this.config,
  //     staticdata: this.staticdata,
  //   }).then((bool: any) => {
        
  //   });
  // }

  // /**
  // *Hàm update class vào database.
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //     [this.device + '_class']: this.class,
  //   }).then((bool: any) => {
      
  //   });
  // }

  generateCode() {
    // Bọc đoạn mã CSS và JS bằng thẻ tương ứng
    this.config.code_value.css = this.wrapWithStyleTag(this.config.code_value.css);
    this.config.code_value.js = this.wrapWithScriptTag(this.config.code_value.js);
    // Cập nhật cấu hình
    this.updateConfig();
  }
  
  wrapWithScriptTag(jsCode: string): string {
    const trimmedCode = jsCode.trim();
    if (trimmedCode.startsWith('<script') && trimmedCode.endsWith('</script>')) {
      return jsCode; // Nếu đã có <script>, không thay đổi
    }
    return `<script>\n${trimmedCode}\n</script>`; // Thêm thẻ <script> nếu chưa có
  }
  
  wrapWithStyleTag(cssCode: string): string {
    const trimmedCode = cssCode.trim();
    if (trimmedCode.startsWith('<style') && trimmedCode.endsWith('</style>')) {
      return cssCode; // Nếu đã có <style>, không thay đổi
    }
    return `<style>\n${trimmedCode}\n</style>`; // Thêm thẻ <style> nếu chưa có
  }

  toggleFullscreen() {
    const dialogRef = this.dialog.open(DialogFullscreenCodeComponent, {
      width: '800px',
      maxWidth: '100%',
      data: this.config.code_value,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.generateCode()
    });
  }
}
